import type addCleaning from '../../../../hosting-server/src/cleaning/functions/addCleaning';
import { createServerHook } from '../../core/hooks/serverHooksCreators';

const useAddCleaning = createServerHook<typeof addCleaning>('addCleaning');

export default useAddCleaning;
